import React, { useEffect, useState } from "react";
import {apiRequestWithAuth} from "../../utils/api";
import Alert from "../../components/ui/alert/Alert";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import Label from "../../components/form/Label";
import Input from "../../components/form/input/InputField";
import ComponentCard from "../../components/common/ComponentCard";
import FileInput from "../../components/form/input/FileInput";
import MyEditor from "../../components/form/input/MyEditor";

type SettingFormData = {
    id: number;
    name: string;
    hotline: string;
    email: string;
    slogan: string;
    logo_file: File | undefined;
    logoPath: string;
    favicon_file: File | undefined;
    faviconPath: string;
    logoBlack: string;
    contact: string;
    bankAccount: string;
    copyright: string;
    metaImage: string;
    metaTitle: string;
    metaKeyword: string;
    metaDescription: string;
};

const defaultForm: SettingFormData = {
    id: 1,
    name: "",
    hotline: "",
    email: "",
    slogan: "",
    logo_file: undefined,
    logoPath: "",
    favicon_file: undefined,
    faviconPath: "",
    logoBlack: "",
    contact: "",
    bankAccount: "",
    copyright: "",
    metaImage: "",
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
};
const Setting = () => {
    const id = 1;
    const [formData, setFormData] = useState<SettingFormData>(defaultForm);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const [faviconPreview, setFaviconPreview] = useState<string | null>(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        const fetchSetting = async () => {
            try {
                const res = await apiRequestWithAuth(`/setting`, "GET", {});
                const data = res.result;
                setFormData(
                    {
                        id: data.id,
                        name: data.name,
                        hotline: data.hotline,
                        email: data.email,
                        slogan: data.slogan,
                        logo_file: data.logo_file,
                        logoPath: data.logoPath,
                        favicon_file: data.favicon_file,
                        faviconPath: data.faviconPath,
                        logoBlack: data.logoBlack,
                        contact: data.contact,
                        bankAccount: data.bankAccount,
                        copyright: data.copyright,
                        metaImage: data.metaImage,
                        metaTitle: data.metaTitle,
                        metaKeyword: data.metaKeyword,
                        metaDescription: data.metaDescription,
                    }
                );

                // Lấy ảnh đầu tiên nếu có
                /*const file = data.files?.find((f: any) => f.metaKey === "image");
                console.log("file", file);
                if (file && file.publicPath) {
                    setPreview(file.publicPath);
                }*/
            } catch (error) {
                console.error("Lỗi khi lấy dữ liệu setting:", error);
            }
        };
        if (id) fetchSetting();
    }, [id]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = "logo_file";
        const value = e.target.files?.[0];
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFaviconChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = "favicon_file";
        const value = e.target.files?.[0];
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        try {
            const frmFormData = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (typeof value === 'string' || typeof value === 'number') {
                    frmFormData.append(key, String(value));
                } else if (value instanceof File) {
                    frmFormData.append(key, value);
                }
            });
            const response = await apiRequestWithAuth(`/setting`, "POST", frmFormData);
            if (response.messageCode && response.messageCode == 200) {
                setFormData((prev) => ({
                    ...prev,
                    logoPath: response.result.logoPath,
                    faviconPath: response.result.faviconPath,
                }));
            }
            console.log("Response from API:", response);
            setOpenSnackbar(true);
        } catch (error) {
            console.error("Failed to update setting:", error);
        }
    };

    return (
        <div>
            {openSnackbar && (
                <Alert
                    variant="success"
                    title="Cập nhật setting thành công"
                    message="Thông tin setting đã được lưu."
                />
            )}

            <PageMeta title="Cập nhật setting" description="Trang chỉnh sửa setting"/>
            <PageBreadcrumb pageTitle="Cập nhật setting"/>

            <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
                <div className="space-y-6">
                    <ComponentCard title="Thông tin setting">
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                                <div>
                                    <Label>Logo</Label>
                                    {/*<input
                                        type="file"
                                        name="logo_file"
                                        onChange={handleChange}
                                    />*/}
                                    <FileInput onChange={handleLogoChange}/>
                                    {formData.logoPath && (
                                        <img
                                            src={formData.logoPath}
                                            alt="Preview"
                                            style={{width: "200px"}}
                                            className="object-cover rounded border mt-2"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                                <div>
                                    <Label>Favicon</Label>
                                    {/*<input
                                        type="file"
                                        name="favicon_file"
                                        onChange={handleChange}
                                    />*/}
                                    <FileInput onChange={handleFaviconChange}/>
                                    {formData.faviconPath && (
                                        <img
                                            src={formData.faviconPath}
                                            alt="faviconPreview"
                                            className="object-cover rounded border mt-2"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                            <div>
                                <Label>Site name</Label>
                                <Input name="name" value={formData.name} onChange={handleChange}/>
                            </div>
                            <div>
                                <Label>Hotline</Label>
                                <Input name="hotline" value={formData.hotline} onChange={handleChange}/>
                            </div>
                            <div>
                                <Label>Email</Label>
                                <Input name="email" value={formData.email} onChange={handleChange}/>
                            </div>
                            <div>
                                <Label>Slogan</Label>
                                <Input name="slogan" value={formData.slogan} onChange={handleChange}/>
                            </div>
                            <div>
                                <Label>Copyright</Label>
                                <Input name="copyright" value={formData.copyright} onChange={handleChange}/>
                            </div>
                        </div>
                        <div className="space-y-6">
                            <div>
                                <Label>Thông tin thanh toán</Label>
                                <MyEditor
                                    content={formData.bankAccount}
                                    onBlur={(value) => handleChange({target: {name: "bankAccount", value}} as any)}
                                />
                            </div>
                        </div>
                        <div className="space-y-6">
                            <div>
                                <Label>Nội dung</Label>
                                <MyEditor
                                    content={formData.contact}
                                    onBlur={(value) => handleChange({target: {name: "contact", value}} as any)}
                                />
                            </div>
                        </div>
                    </ComponentCard>
                </div>
                <button
                    onClick={handleSave}
                    className="mt-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300"
                >
                    Lưu cấu hình
                </button>
            </div>
        </div>
    );
}
export default Setting;